module.exports = __webpack_public_path__ + "img/mother.5bcef7c6.svg";